/**
 * NEWS
 */
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID } from '@/_modules/utils/variables';
// vue
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalFooter from '@/_components/global-footer.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import Refine from '@/_components/refine.vue';

import scrollManager from '@/_modules/common/scrollManager';
import subBg from '@/_modules/common/subBg';
import hover from '@/_modules/common/hover';
window.$scrollManager = scrollManager;

export default class AppNews {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppNews';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    new subBg();

    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        GlobalHeader,
        GlobalFooter,
        GlobalNavi,
        Refine
      },
      data() {
        return {
          ispc: false,
          isLoaded: false,
          isState: '',
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {
        $scrollManager.init();

        document.querySelectorAll('.c-newsList__set').forEach((el, index) => {
          new hover(el, index);
        });

        this.$nextTick(this.start);
      },
      methods: {
        start() {
          this.$store.commit('setShowCoverOut', false);
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        }
      }
    });
  }
}
